import config from '../config/index';
import { request } from './api';
const urls = {
  getUserInfo: '/vrapi/autouser/getUserInfo',
  getAutoLoginedUserId: '/vrapi/autouser/getLoginInfo',
  createMobileCode: '/vractivity/ajaxnocache/createMobileCode',
  regOrLoginByMobileCode: '/vractivity/ajaxnocache/regOrLoginByMobileCode',
};
export default {
  /**
   * 用户是否登录
   */
  getAutoLoginedUserId() {
    return request({
      type: 'get',
      url: config.dealerCloudVrapi + urls.getAutoLoginedUserId,
      data: {},
      crossDomain: true,
      xhrFields: { withCredentials: true },
    });
  },
  getUserInfo() {
    return request({
      type: 'get',
      url: config.dealerCloudVrapi + urls.getUserInfo,
      data: {},
      crossDomain: true,
      xhrFields: { withCredentials: true },
      transformResponse: function (data) {
        if (data.returncode === 0 && data.result) {
          var realName = data.result.RealName || '';
          const nickName = data.result.NickName || '';
          var phone = data.result.MobilePhone || '';
          return {
            returncode: 0,
            message: '',
            result: { realName, nickName, phone },
          };
        } else {
          return { returncode: 1, message: '没有获取到用户信息', result: data };
        }
      },
    });
  },
  /**
   * 获取之家登录验证码
   * @param { object } 手机号
   * @returns
   */
  createMobileCode({ phone }) {
    return request({
      type: 'post',
      dataType: 'json',
      contentType: 'application/json;charset=UTF-8',
      data: JSON.stringify({ phone }),
      url: config.dealerCloud + urls.createMobileCode,
      transformResponse: function (data) {
        if (data.returncode === 0) {
          return { returncode: 0, message: '', result: data };
        } else {
          return {
            returncode: 1,
            message: '获取汽车之家验证码失败',
            result: data,
          };
        }
      },
    });
  },
  /**
   * 注册或者登录之家账户
   * @param { Object } 手机号&验证码
   * @returns
   */
  regOrLoginByMobileCode({ phone, code }) {
    return request({
      type: 'post',
      dataType: 'json',
      contentType: 'application/json;charset=UTF-8',
      data: JSON.stringify({ mobilePhone: phone, validCode: code }),
      url: config.dealerCloud + urls.regOrLoginByMobileCode,
      transformResponse: function (data) {
        if (data.returncode === 0) {
          return { returncode: 0, message: '', result: data };
        } else {
          return {
            returncode: 1,
            message: '获取汽车之家登录失败',
            result: data,
          };
        }
      },
    });
  },
};
